import {format, isValid, parse} from 'date-fns'
import {enGB, es, fr, nl} from 'date-fns/locale'

import {useLanguage} from './i18n'

const DISPLAY_FORMAT = 'dd/MM/yyyy'

export const toDisplayDate = (date: Date, displayFormat = DISPLAY_FORMAT) =>
	format(date, displayFormat)

export const fromDisplayDate = (
	dateString: string,
	displayFormat = DISPLAY_FORMAT
) => dateString && parse(dateString, displayFormat, new Date())

export const fromDisplayDateWithTime = (
	dateString: string,
	hourString: string,
	displayFormat = DISPLAY_FORMAT
) => {
	const date = fromDisplayDate(
		dateString + ' ' + hourString,
		displayFormat + ' HH:mm'
	)
	return isValid(date) ? date : fromDisplayDate(dateString, displayFormat)
}

export const toServerDate = (dateString: string) => {
	const parsed = fromDisplayDate(dateString)
	return isValid(parsed) ? format(parsed, 'yyyy-MM-dd') : null
}

export const dateFromServerDate = (dateString: string) => {
	const parsed = parse(dateString, 'yyyy-MM-dd HH:mm:ss', new Date())
	return isValid(parsed) ? parsed : null
}

export const fromServerDate = (dateString: string) => {
	const parsed = parse(dateString, 'yyyy-MM-dd HH:mm:ss', new Date())
	return isValid(parsed) ? toDisplayDate(parsed) : null
}

export const formatDate = (date, displayFormat = DISPLAY_FORMAT) => {
	if (!isValid(new Date(date))) return date

	return format(parse(date, 'yyyy-MM-dd HH:mm:ss', new Date()), displayFormat, {
		locale: switchLocale()
	})
}

export const switchLocale = () => {
	const lang = useLanguage()

	switch (lang) {
		case 'en':
			return enGB

		case 'es':
			return es

		case 'fr':
			return fr

		default:
			return nl
	}
}
